// api 统一配置 两端共用
export const CROSS_API = {
  wallet: {
    submitFiatWithdraw: "/v3/wallet/fiat/withdrawal", // 申请法币出金
    fiatWithdrawList: "/v3/wallet/fiat/orders", // 法币出金列表
    fiatWithdrawDetail: "/v3/wallet/fiat/order/{id}", // 法币出金详情
  },
  ai: {
    loginEdgen: "/v3/auth/customer/login-edgen",
  },
};
